import Select, { MultiValue } from "react-select";
import { CameraItem, SelectableCameraItem } from "../../models/Camera";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { getCameraFilters } from "../../services/Camera";
import { Spinner } from "react-bootstrap";

// Extend CameraItem for react-select compatibility

interface CameraProps {
  mode?: string;
  allCameras: SelectableCameraItem[];
  setAllCameras: Dispatch<SetStateAction<SelectableCameraItem[]>>;
  selectedCameras: SelectableCameraItem[];
  setSelectedCameras: Dispatch<SetStateAction<SelectableCameraItem[]>>;
}

const CamerasFilter: React.FC<CameraProps> = ({
  mode,
  allCameras,
  setAllCameras,
  selectedCameras,
  setSelectedCameras,
}) => {
  const [loading, setLoading] = useState(true);

  const loadCameras = () => {
    setLoading(true);
    const getCameras$ = getCameraFilters();
    const sub = getCameras$.subscribe({
      next: (res) => {
        console.log("res from camera", res);
        let mapped_data = res?.map((model: CameraItem) => ({
          ...model,
          value: model.camera_id,
          label: model.camera_id.toString(),
        }));

        setAllCameras([
          { value: -1, label: "Select All", camera_id: -1 }, // Add `camera_id`
          ...mapped_data,
        ]);

        if (mapped_data.length > 0) {
          setSelectedCameras([mapped_data[0]]);
        }

        setLoading(false);
      },
      error: (error) => {
        console.error("Error loading cameras:", error);
        setLoading(false);
      },
    });
    return () => sub.unsubscribe();
  };

  useEffect(() => {
    loadCameras();
  }, []);

  const handleCameraSelectChange = (
    selectedOptions: MultiValue<SelectableCameraItem>
  ) => {
    if (!selectedOptions) {
      setSelectedCameras([]);
      return;
    }

    if (selectedOptions.some((option) => option.value === -1)) {
      // Fix: Check for -1 instead of "select_all"
      setSelectedCameras(allCameras.slice(1)); // Select all except "Select All"
    } else {
      setSelectedCameras(selectedOptions as SelectableCameraItem[]);
    }
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "70px",
            textAlign: "center",
          }}
        >
          <Spinner
            animation="border"
            role="status"
            style={{ marginBottom: "10px" }}
          >
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <div>Loading cameras filter ...</div>
        </div>
      ) : (
        <div>
          {allCameras.length > 0 && (
            <div className="mb-1">
              <span className="d-block fw-bold mb-1">
                <small>Cameras:</small>
              </span>
              <Select
                inputId="camera-select"
                options={allCameras}
                isMulti
                value={selectedCameras} // Fix: Use `value`
                onChange={handleCameraSelectChange}
                placeholder="Select..."
                className="basic-multi-select"
                classNamePrefix="select"
                styles={{
                  control: (provided) => ({
                    ...provided,
                    borderColor: "#d1d7e0",
                    fontSize: 13,
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    color: "#506690",
                  }),
                  option: (provided) => ({
                    ...provided,
                    fontSize: 13,
                  }),
                }}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default CamerasFilter;
